<template>
    <div>
        <h1 class="text-center text-20">{{ $t("views.login.title") }}</h1>
        <Alert v-if="data.errorMessage" type="error" :message="data.errorMessage" show-icon class="mb-3"></Alert>
        <Form :ref="e => (refs.form = e)" layout="vertical">
            <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields"></TemplateBuilder>
        </Form>
        <div class="d-flex">
            <router-link :to="{ name: 'register' }">
                <Button>
                    <span>{{ $t("button.register") }}</span>
                </Button>
            </router-link>
            <router-link :to="{ name: 'request-short-details' }">
                <Button class="btn-info ml-2">
                    <span>{{ $t("button.searchShortDetail") }}</span>
                </Button>
            </router-link>
            <Button class="ml-auto px-3 btn-primary" @click="() => onClickLogin({ props, data, refs })" :disabled="isLoading">
                <CIcon file="login.svg"></CIcon>
                <span>{{ $t("button.login") }}</span>
            </Button>
        </div>
        <div class="d-flex mt-2 pl-3">
            <router-link :to="{ name: 'register-officer' }"> {{ $t("views.register.registerOfficer") }}</router-link>
            <router-link class="ml-auto" :to="{ name: 'forgot-password' }"> {{ $t("button.forgotPassword") }} ?</router-link>
        </div>
    </div>
</template>

<script>
import { Alert, Button, Form } from "ant-design-vue";
import { defineAsyncComponent, defineComponent, reactive } from "vue";
import { isLoading, initForm, onClickLogin } from "./login.logic";

export default defineComponent({
    components: {
        TemplateBuilder: defineAsyncComponent(() => import("../../../components/input/template-builder/TemplateBuilder")),
        Form,
        Button,
        Alert,
        CIcon: defineAsyncComponent(() => import("../../../components/icon/CIcon"))
    },
    setup(props) {
        const data = reactive({ rowProp: { gutter: 24 }, errorMessage: null });
        const refs = reactive({ form: null });
        initForm({ props, data, refs });
        return { props, data, refs, isLoading, onClickLogin };
    }
});
</script>
